import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { FieldErrors, useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import cn from 'classnames'

import Button from 'components/Button'
import UserInfoInput from 'components/UserInfoInput'
import ButtonIcon from 'components/ButtonIcon'
import SocialLink from 'components/SocialLink'

import { toast } from 'App'
import { useStore } from 'store'

import styles from './styles.module.scss'
import { StreamSettingsModal } from '../StreamSettingsModal'

interface IProps {}

//Resize
const UserStreamSettings: React.FC<IProps> = observer(() => {
  const { profile } = useStore()
  const [isOpenStreamSettingsModal, setIsOpenStreamSettingsModal] = useState(false)

  const openStreamSettingsModal = () => {
    setIsOpenStreamSettingsModal(true)
  }

  const onChangeOpenStreamSettingsModal = (value: boolean) => {
    setIsOpenStreamSettingsModal(value)
  }

  if (!profile.selectedUser.Activated) return null

  return (
    <div className={styles.container}>
      <div className={styles.titleBlock}>
        <div className={styles.title}>Stream Settings</div>
        <ButtonIcon
          icon={'edit'}
          onClick={openStreamSettingsModal}
        />
      </div>

      {isOpenStreamSettingsModal ?
        <StreamSettingsModal isOpen={isOpenStreamSettingsModal} setIsOpen={onChangeOpenStreamSettingsModal}/>
        : null}

    </div>
  )
})

export default UserStreamSettings
